const CreditStatus = {
  NOT_APPLIED: 'CREDIT_NOT_APPLIED',
  PENDING_APPROVAL: 'CREDIT_PENDING_APPROVAL',
  APPROVED: 'CREDIT_APPROVED',
  ACTIVE: 'CREDIT_ACTIVE',
  USED: 'CREDIT_USED',
  OVERDUE: 'CREDIT_OVERDUE',
  REJECTED: 'CREDIT_REJECTED',
  BLOCKED: 'CREDIT_BLOCKED',
};

export default CreditStatus;
